<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import BlogEntryListItem from './components/BlogEntryListItem';

export default {
  name: 'InfoPortal',
  components: {
    BlogEntryListItem,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Titel', value: 'headline' }, { text: 'Aktionen', value: '' }],
    };
  },
  computed: {
    ...mapState(['blogEntryList']),
    ...mapState('blogEntryList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('blogEntryList', { fetchData: 'fetchBlogEntryList' }),
    ...mapActions('blogEntryDetails', ['deleteBlogEntry']),
    onDelete() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onRefresh() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onNewBlogEntry() {
      this.$router.push('/blogEntryDetails');
    },
    parseDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
  },
};
</script>

<template>
  <div>
    <div v-for="blogEntry in blogEntryList.data" :key="blogEntry.id">
      <v-flex xs12 md12>
        &nbsp;
      </v-flex>
      <div style="border:1px solid #E0E0E0; padding:15px;">
        <v-layout row>
          <v-flex xs12 md10>
            <h3>{{ blogEntry.headline }}</h3>
          </v-flex>
          <v-flex xs12 md2>
            <span style="float:right; font-size:12px;">{{ parseDate(blogEntry.dateCreated) }}</span>
          </v-flex>
        </v-layout>
        <p v-html="blogEntry.text" />
      </div>
      <v-flex xs12 md12>
        &nbsp;
      </v-flex>
    </div>
  </div>
</template>
